import React, { useState } from 'react'
import { Episode, FullSupportInformation } from 'types'
import * as Styled from './EpisodeCard.styled'
import EpisodeCoverButton from '../EpisodeCoverButton/EpisodeCoverButton'
import ExclusiveContentModal from 'components/ExclusiveContentModal/ExclusiveContentModal'

export interface EpisodeCardProps
  extends Pick<Episode, 'image' | 'title' | 'releaseDate' | 'description'> {
  blockedForSupporters: boolean
  duration: string
  onPlay: () => Promise<void> | void
  onStop: () => void
  onSkip: () => void
  onRewind: () => void
  isPlaying: boolean
  currentTime?: string
  userLoggedIn: boolean
  podcastId: string
  episodeId?: string
  idx?: number
  podcastFullSupportInformation: FullSupportInformation
  minSupportTierId: string | null
  supportTiersIds: string[] | null
}

const EpisodeCard: React.FC<EpisodeCardProps> = ({
  blockedForSupporters,
  duration,
  image,
  title,
  releaseDate,
  description,
  onPlay,
  onStop,
  onSkip,
  onRewind,
  isPlaying,
  currentTime,
  userLoggedIn,
  podcastId,
  episodeId,
  idx,
  podcastFullSupportInformation,
  minSupportTierId,
  supportTiersIds,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  return (
    <>
      <ExclusiveContentModal
        isOpen={isModalOpen}
        handleClose={handleCloseModal}
        fullSupportInformation={podcastFullSupportInformation}
        minSupportTierId={minSupportTierId}
        supportTiersIds={supportTiersIds}
      />

      <Styled.EpisodeCard isOdd={idx && idx % 2 === 1}>
        <EpisodeCoverButton
          isPlaying={isPlaying}
          episodeImage={image}
          onPlay={onPlay}
          onStop={onStop}
          onSkip={onSkip}
          onRewind={onRewind}
          blockedForSupporters={blockedForSupporters}
          userLoggedIn={userLoggedIn}
          onExclusiveToSupporter={handleOpenModal}
          onNonLoggedIn={handleOpenModal}
        />
        <Styled.InfoWrapper>
          <Styled.EpisodeTitle numOfCharacters={title.length}>
            {title} {blockedForSupporters && <Styled.PadlockWithMargin />}
          </Styled.EpisodeTitle>
          <Styled.AdditionalInfo>{releaseDate}</Styled.AdditionalInfo>
        </Styled.InfoWrapper>
      </Styled.EpisodeCard>
    </>
  )
}

export default EpisodeCard
